





































import { Component, Vue } from 'vue-property-decorator'

import ChromeText from './components/ImageText/ChromeText.vue'
import EEText from './components/ImageText/EEText.vue'
import SEText from './components/ImageText/SEText.vue'
import SGText from './components/ImageText/SGText.vue'
import QQText from './components/ImageText/QQText.vue'
import EdgeText from './components/ImageText/EdgeText.vue'
import LiebaoText from './components/ImageText/LiebaoText.vue'
import ThousandText from './components/ImageText/ThousandText.vue'

import ChromeVideo from './components/Video/ChromeVideo.vue'
import EEVideo from './components/Video/EEVideo.vue'
import SEVideo from './components/Video/SEVideo.vue'
import SGVideo from './components/Video/SGVideo.vue'
import QQVideo from './components/Video/QQVideo.vue'
import EdgeVideo from './components/Video/EdgeVideo.vue'
import LiebaoVideo from './components/Video/LiebaoVideo.vue'
import ThousandVideo from './components/Video/ThousandVideo.vue'

import ProblemOne from './components/Problem/ProblemOne.vue'
import ProblemTwo from './components/Problem/ProblemTwo.vue'
import ProblemTree from './components/Problem/ProblemTree.vue'
import ProblemFour from './components/Problem/ProblemFour.vue'
import Problemlose from './components/Problem/Problemlose.vue'
import ProblemSE from './components/Problem/ProblemSE.vue'
import ProblemEE from './components/Problem/ProblemEE.vue'

@Component({
  components: {
    ChromeText,
    EEText,
    SEText,
    SGText,
    QQText,
    EdgeText,
    LiebaoText,
    ThousandText,
    ChromeVideo,
    EEVideo,
    SEVideo,
    SGVideo,
    QQVideo,
    EdgeVideo,
    LiebaoVideo,
    ThousandVideo,
    ProblemOne,
    ProblemTwo,
    ProblemTree,
    ProblemFour,
    Problemlose,
    ProblemSE,
    ProblemEE
  }
})
export default class Course extends Vue {
  active = 'ChromeText'
  downloadUrl = window.location.origin + '/plugs'
  openeds: string[] = ['ImageText', 'Video', 'Problem']
  courseList: {}[] = [
    {
      name: '图文教程',
      value: 'ImageText',
      list: [
        // {
        //   name: '方法一（适用于crx文件安装）',
        //   value: 'MethodOne'
        // },
        // {
        //   name: '方法二（适用于zip文件安装）',
        //   value: 'MethodTwo'
        // },
        // {
        //   name: '方法三（搜狗高速浏览器安装）',
        //   value: 'MethodTree'
        // },
        {
          name: 'Chrome浏览器',
          value: 'ChromeText'
        },
        {
          name: '360安全浏览器',
          value: 'EEText'
        },
        {
          name: '360极速浏览器',
          value: 'SEText'
        },
        {
          name: '搜狗高速浏览器',
          value: 'SGText'
        },
        {
          name: 'QQ浏览器',
          value: 'QQText'
        },
        {
          name: 'Edge浏览器',
          value: 'EdgeText'
        },
        {
          name: '猎豹浏览器',
          value: 'LiebaoText'
        },
        {
          name: '2345加速浏览器',
          value: 'ThousandText'
        }
      ]
    },
    {
      name: '视频教程',
      value: 'Video',
      list: [
        {
          name: 'Chrome浏览器',
          value: 'ChromeVideo'
        },
        {
          name: '360安全浏览器',
          value: 'EEVideo'
        },
        {
          name: '360极速浏览器',
          value: 'SEVideo'
        },
        {
          name: '搜狗高速浏览器',
          value: 'SGVideo'
        },
        {
          name: 'QQ浏览器',
          value: 'QQVideo'
        },
        {
          name: 'Edge浏览器',
          value: 'EdgeVideo'
        },
        {
          name: '猎豹浏览器',
          value: 'LiebaoVideo'
        },
        {
          name: '2345加速浏览器',
          value: 'ThousandVideo'
        }
      ]
    },
    {
      name: '常见问题',
      value: 'Problem',
      list: [
        {
          name: '1.安装提示无法从该网站添加...',
          value: 'ProblemOne'
        },
        {
          name: '2.Mac系统安装浏览器插件',
          value: 'ProblemTwo'
        },
        {
          name: '3.猎豹浏览器为什么不显示插件',
          value: 'ProblemTree'
        },
        {
          name: '4.安装插件提示程序包无效',
          value: 'ProblemFour'
        },
        {
          name: '5.开发者模式安装后插件丢失',
          value: 'Problemlose'
        },
        {
          name: '6.360极速浏览器自动关闭插件',
          value: 'ProblemSE'
        },
        {
          name: '7.360安全浏览器自动关闭插件',
          value: 'ProblemEE'
        }
      ]
    }
  ]

  changeActive(index: string) {
    this.active = index
  }

  handleOpen(key: string, keyPath: []) {
    console.log(key, keyPath)
  }
  handleClose(key: string, keyPath: []) {
    console.log(key, keyPath)
  }

  //   changeCourse() {
  //     this.$router.push('/plugs')
  //   }
}
